import React from 'react';
import { RadioButton } from "../..";

import { createStyles } from "./styles";

// This component is distracted into separate component instead of using just
// simple RadioButton for the sake of possible future additions of the functional.
var RadioInputOption = function RadioInputOption(props) {
  var classes = createStyles(!!(props !== null && props !== void 0 && props.guidelines));

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.radioWrapper }, /*#__PURE__*/
    React.createElement(RadioButton, props)));


};

export default RadioInputOption;
//# sourceMappingURL=index.js.map